import React from "react";

import { Flex } from "components";

export type StepItemCardProps = {
  stepNumber: number;
  title: string;
  description: string;
  className?: string;
  dataTestId?: string;
};

export const StepItemCard: React.FC<StepItemCardProps> = ({ stepNumber, title, description }) => (
  <div>
    <Flex vertical className="margin-bottom-150">
      <Flex align="center" gap="0.5rem" className="margin-bottom-0">
        <div className="step-item-circle-number">
          <p className="paragraph-s">{stepNumber}</p>
        </div>
        <p className="paragraph-m-bold margin-top-0 margin-bottom-0">{title}</p>
      </Flex>
      <p className="paragraph-s margin-top-0 margin-bottom-0 padding-left-200 grey-600-text">{description}</p>
    </Flex>
  </div>
);

export default StepItemCard;
